export default "__VITE_ASSET__BbwXiZis__"